<template>
    <b-modal ref="modal" centered scrollable hide-header hide-footer>
        <div class="project-actions">
            <b-nav>
                <b-nav-item @click="deleteProject()">Delete Project</b-nav-item>
                <b-nav-item @click="cancel()">Cancel</b-nav-item>
            </b-nav>
        </div>
    </b-modal>
</template>

<script>
    export default {
        name: "ProjectActionsModal",
        props:{
            projectIndex: Number,
        },
        methods: {
            deleteProject() {
                this.$emit('open-delete-modal', this.projectIndex)
            },
            cancel() {
                this.$refs.modal.hide()
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"

    .project-actions
        padding 1em 0
        .nav
            display flex
            flex 1
            .nav-item
                flex-direction column
                text-align center
                width 100%
                a
                    color color-black
                    font font-poppins-semibold !important
                    font-size 14px !important
                    &:hover
                        color color-black
</style>